import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { tracking } from '#features/analytics';
import { Link } from '#features/routing';
import { Button } from '#features/ui';

type StickyMobileCtaProps = {
  label: string;
  accentColor: string;
};

/**
 * Persistent primary CTA pinned to the bottom on mobile - appears once the
 * visitor scrolls past the hero, so the conversion action is always one tap
 * away on a long page. Desktop keeps the header + in-page CTAs.
 */
export const StickyMobileCta = ({ label, accentColor }: StickyMobileCtaProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Box
      display={{ base: 'block', md: 'none' }}
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={1200}
      px={4}
      pt={3}
      pb="calc(env(safe-area-inset-bottom, 0px) + 12px)"
      background="linear-gradient(to top, hsl(228, 11.6%, 6%) 60%, transparent)"
      transform={show ? 'translateY(0)' : 'translateY(120%)'}
      opacity={show ? 1 : 0}
      transition="transform 0.3s ease, opacity 0.3s ease"
      pointerEvents={show ? 'auto' : 'none'}
    >
      <Button
        w="100%"
        size="lg"
        style={{ boxShadow: `0 0 24px ${accentColor}55` }}
        onClick={() => tracking.event({ action: 'click_get_started' })}
        asChild
      >
        <Link to="/{-$locale}/sign-up">{label}</Link>
      </Button>
    </Box>
  );
};
